import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { IconButton, styled } from '@mui/material';

interface SidebarToggleButtonProps {
  isCollapsed: boolean;
  onToggle: () => void;
}

const ToggleButtonWrapper = styled('div')(
  ({ theme }) => `
  position: absolute;
  top: 141px;
  right: -17px;
  z-index: 1000;
  background: ${theme.palette.background.paper};
  border: 1px solid ${theme.palette.divider};
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    background: ${theme.palette.action.hover};
    transform: scale(1.1);
  }
`
);

const StyledIconButton = styled(IconButton)(
  ({ theme }) => `
  padding: 0;
  width: 20px;
  height: 20px;

  .MuiSvgIcon-root {
    font-size: 22px;
    color: ${theme.palette.text.secondary};
  }
`
);

const SidebarToggleButton = ({
  isCollapsed,
  onToggle,
}: SidebarToggleButtonProps) => {
  /* Hooks & Use Effects */

  /* States */

  /* API Calls */

  /* Functions & Functional Components */

  return (
    <ToggleButtonWrapper onClick={onToggle}>
      <StyledIconButton size='small'>
        {isCollapsed ? <ChevronRight /> : <ChevronLeft />}
      </StyledIconButton>
    </ToggleButtonWrapper>
  );
};

export default SidebarToggleButton;
